module.exports = "/images/our-service-bg.jpg?395258808f8888df0a173fa42373587d";